$(function(){
  console.log('Initial');
});

jscTab = (e,index) =>{
  // head declaration
  var $heads = $('.jsc-tab-head');
  var $selectedHead = $('#jsc-tab-head-'+index);
  // content declaration
  var $contents = $('.jsc-tab-content');
  var $selectedContent = $('#jsc-tab-content-'+index);

  // Reset tab
  $contents.hide();
  $heads.removeClass('jsc-tab-active');

  // Set selected tab
  $selectedContent.show();
  $selectedHead.addClass('jsc-tab-active');
}

jscATC = (e, vid) =>{
  jQuery.post('/cart/add.js', {
    items: [
      {
        quantity: 1,
        id: parseInt(vid)
      }
    ]
  })
  .done(function() {
    setTimeout(function(){
      $jsc_this.cartForm.buildCart();
      $jsc_this.open();
    },1200);
  })
  .fail(function() {
    console.log( "error" );
  });
  // jQuery.post('/cart/clear.js');
}
